import { Pipe, PipeTransform } from "@angular/core";
import { toDate } from "date-fns-tz";

@Pipe({
	name: "localizeDate",
})
export class LocalizeDatePipe implements PipeTransform {
	transform(utcDate?: any): Date | null {
		return utcDate ? toDate(utcDate, { timeZone: "UTC" }) : null;
	}
}
